import { FC } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser');

    return <div className={css.thecomp}>{t('banner.title')}</div>;
};

export default TheComp;
